import { memo, useEffect, useState } from 'react';
import cls from 'classnames';

import { svgStringToHTML } from '@/utils/svgStringToHTML';

import styles from './SVGDiagram.module.scss';

interface SVGDiagramProps {
  url: string;
  className?: string;
}

function SVGDiagram(props: SVGDiagramProps) {
  const { url, className } = props;

  const isSVG = url?.includes('.svg');

  const [svgContent, setSvgContent] = useState<Nullable<string>>(null);

  function renderSVGContent() {
    if (svgContent) {
      const classNameComp = cls(styles.image, className);

      return <div className={classNameComp} dangerouslySetInnerHTML={{ __html: svgContent }} />;
    }

    return null;
  }

  async function getSVGContent(path: string) {
    try {
      const svgElement = await svgStringToHTML(path);

      const box = svgElement?.querySelector('.BoundingBox');
      const x = box?.getAttribute('x');
      const y = box?.getAttribute('y');
      const width = box?.getAttribute('width');
      const height = box?.getAttribute('height');

      svgElement?.querySelectorAll('.TextParagraph').forEach((element) => {
        const fontSize = element.getAttribute('font-size');

        if (!fontSize) {
          return;
        }

        const [value] = /\d+/g.exec(fontSize) ?? [];

        element.setAttribute('font-size', `${Number(value) * 1.2}px`);
      });

      if (typeof x !== 'undefined' && typeof y !== 'undefined' && typeof width !== 'undefined' && typeof height !== 'undefined') {
        svgElement?.setAttribute('viewBox', `${x} ${y} ${width} ${height}`);
      }

      svgElement?.removeAttribute('width');
      svgElement?.removeAttribute('height');

      setSvgContent(svgElement?.outerHTML ?? null);
    } catch (e) {
      //
    }
  }

  useEffect(() => {
    if (isSVG) {
      getSVGContent(url);
    }
  }, [url]);

  if (!isSVG) {
    return null;
  }

  return renderSVGContent();
}

export default memo(SVGDiagram);
